<template>
  <div id="app">
    <app-header v-show="header_show"></app-header>
    <transition name="el-fade-in-linear">
      <router-view v-on:header="header" v-on:footer="footer"></router-view>
    </transition>
    <app-footer v-if="footer_show" :footerlink="footerlink"></app-footer>
  </div>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
// import { GET_FOOTER } from '@/api/mall';
import { WOW } from "wowjs";
export default {
  name: "App",
  data() {
    return {
      transitionName: "",
      header_show: true,
      footer_show: true,
      footerlink: []
    };
  },
  components: {
    "app-header": Header,
    "app-footer": Footer
  },
  mounted() {
    this.ongetFooter();
  },
  methods: {
    ongetFooter() {
      this.$store
        .dispatch("getfooter")
        .then(data => {
          this.footerlink = data;
        })
        .catch(error => {});
    },
    // 是否显示头部
    header(bool) {
      this.header_show = bool;
    },
    // 是否显示底部
    footer(bool) {
      this.footer_show = bool;
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue